module.exports = __webpack_public_path__ + "img/CousinUndCousine.a920d960.jpg";